export default __webpack_public_path__ + "static/media/install-app-3-android.b3682ab8.jpg";